import React from 'react'
import { RadioButton } from '@livechat/design-system'

const SingleChoiceAnswer = ({ field, response, setResponse, index }) => {
  return field?.answers?.map((answer, i) => {
    return (
      <RadioButton
        key={answer}
        checked={response[index] === i}
        onChange={() =>
          setResponse({
            ...response,
            [index]: i,
          })
        }
      >
        {answer}
      </RadioButton>
    )
  })
}

export default SingleChoiceAnswer
